<template>
  <base-layout :menu-items="menuItems" />
</template>

<script>
  import BaseLayout from './BaseLayout.vue'
  import { mapState } from 'vuex'
  import { CURRENT_USER } from '@/constants/store.js'

  export default {
    name: 'App',
    components: {
      BaseLayout
    },
    computed: {
      ...mapState(CURRENT_USER.NAMESPACE, {
        isTopManager: state => state[CURRENT_USER.STATE.IS_TOP_MANAGER]
      }),
      menuItems () {
        const items = [
          {
            heading: this.$t('Личный кабинет'),
            show: true,
            list: [
              {
                id: 'exit',
                icon: 'exit_to_app',
                text: this.$t('Выйти'),
                route: '',
                method: this.logOut,
                show: this.isLoggedIn
              },
              {
                id: 'registration',
                icon: 'person',
                text: this.$t('Регистрация'),
                route: `${this.urlRootPath}/user/registration/start`,
                show: this.isLoggedIn &&
                  !this.isRegistered
              },
              {
                id: 'login',
                icon: 'person',
                text: this.$t('Войти'),
                route: `${this.urlRootPath}/login`,
                show: !this.isLoggedIn
              },
              {
                id: 'organization',
                icon: 'business',
                text: this.$t('Организация'),
                route: `${this.urlRootPath}/user/organization`,
                show: this.isLoggedIn &&
                  this.isRegistered
              },
              {
                id: 'proxies',
                icon: 'contacts',
                text: this.$t('Список документов УП'),
                route: `${this.urlRootPath}/user/proxies`,
                show: this.isLoggedIn &&
                  this.isRegistered &&
                  !this.isTopManager
              },
              {
                id: 'resetPassword',
                icon: 'settings_backup_restore',
                text: this.$t('Сбросить пароль'),
                route: `${this.urlRootPath}/resetPassword`,
                show: !this.isLoggedIn
              },
              {
                id: 'changePassword',
                icon: 'settings_backup_restore',
                text: this.$t('Изменить пароль'),
                route: `${this.urlRootPath}/changePassword`,
                show: this.isLoggedIn
              },
              {
                id: 'paymentsGeneration',
                icon: 'receipt',
                text: this.$t('Формирование платежных поручений'),
                route: `${this.urlRootPath}/paymentsGeneration`,
                show: true
              }
            ]
          },
          {
            heading: this.$t('Торговые процедуры'),
            show: true,
            list: [
              {
                id: 'published',
                icon: 'gavel',
                text: this.$t(this.isLoggedIn && this.isRegistered
                  ? 'Список опубликованных торговых процедур'
                  : 'Список торговых процедур'),
                route: `${this.urlRootPath}/lots/published`,
                show: true
              },
              {
                id: 'personal',
                icon: 'gavel',
                text: this.$t('Мои торговые процедуры'),
                route: `${this.urlRootPath}/lots/personal`,
                show: this.isLoggedIn && this.isRegistered
              },
              {
                id: 'personal',
                icon: 'gavel',
                text: this.$t('Мои шаблоны'),
                route: `${this.urlRootPath}/templates`,
                show: this.isLoggedIn &&
                  this.isRegistered &&
                  this.isOrganizer
              },
              {
                id: 'lotRegistration',
                icon: 'add_box',
                text: this.$t('Создать торговую процедуру'),
                route: `${this.urlRootPath}/lotRegistration`,
                show:
                  this.isLoggedIn &&
                  this.isRegistered &&
                  this.isOrganizer
              },
              {
                id: 'summarizing',
                icon: 'ballot',
                text: this.$t('Подведение итогов'),
                route: `${this.urlRootPath}/lots/summarizing`,
                show:
                  this.isLoggedIn &&
                  this.isRegistered &&
                  this.isOrganizer
              }
            ]
          },
          {
            heading: this.$t('Общая информация'),
            show: true,
            list: [
              {
                icon: 'work',
                text: this.$t('Основные документы'),
                route: `${this.urlRootPath}/generalDocuments`,
                show: true
              },
              {
                icon: 'chat_bubble',
                text: this.$t('Служба поддержки'),
                route: `${this.urlRootPath}/support`,
                show: true
              }
            ]
          }
        ]

        return items
      }
    }
  }
</script>
